// extracted by mini-css-extract-plugin
export default {"selectionOption":"Selection_selectionOption__Tt38n"};